exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-edit[data-v-2a540d1a]{background-color:#d3ebef;border-radius:5px;margin:1rem}.label-cs[data-v-2a540d1a]{min-width:fit-content}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a540d1a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/partners/CategoryCompo.vue
// module id = 673
// module chunks = 27